export const LogoMark = ({ size = 36, dark = false, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M20 4V36M20 4L10 14M20 4L30 14M12 20C12 24.4183 15.5817 28 20 28C24.4183 28 28 24.4183 28 20"
      stroke={dark ? "#FBF9F5" : "#1A1917"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="20" cy="20" r="2" fill="#C5A059" />
  </svg>
);

export const Wordmark = ({ dark = false }) => (
  <span
    className={`font-serif text-lg leading-none tracking-tight ${
      dark ? "text-bone" : "text-noir"
    }`}
  >
    Kasey <span className="italic text-gold">Beaumont</span>
  </span>
);
